import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser, loginUser, registerUser, loginWithSocial, logoutUser, getUserLoyaltyInfo } from '../utils/storage';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loyaltyInfo, setLoyaltyInfo] = useState({
    totalBookings: 0,
    stamps: 0,
    remainingForReward: 10,
    isRewardEligible: false,
    rewardType: 'free_haircut',
    rewardsEarned: 0
  });

  const refreshUser = () => {
    const user = getCurrentUser();
    setCurrentUser(user);
    if (user) {
      const info = getUserLoyaltyInfo(user.id, user.phone);
      setLoyaltyInfo(info);
    } else {
      setLoyaltyInfo({
        totalBookings: 0,
        stamps: 0,
        remainingForReward: 10,
        isRewardEligible: false,
        rewardType: 'free_haircut',
        rewardsEarned: 0
      });
    }
  };

  useEffect(() => {
    refreshUser();

    const handleCustomChange = (e) => {
      const type = e?.detail?.type;
      if (
        type === 'USER_LOGGED_IN' || 
        type === 'USER_REGISTERED' || 
        type === 'USER_UPDATED' || 
        type === 'USERS_UPDATED' || 
        type === 'USER_STAMPS_UPDATED' || 
        type === 'APPOINTMENT_SAVED' ||
        type === 'APPOINTMENT_STATUS_UPDATED' ||
        type === 'APPOINTMENT_PAYMENT_RECORDED' ||
        type === 'APPOINTMENTS_SYNCED'
      ) {
        refreshUser();
      }
    };

    const handleStorage = (e) => {
      if (e.key === 'aurahair_current_user' || e.key === 'aurahair_users_v1' || e.key === 'aurahair_appointments_v1') {
        refreshUser();
      }
    };

    window.addEventListener('aurahair_data_change', handleCustomChange);
    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('aurahair_data_change', handleCustomChange);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const login = (credentials) => {
    const res = loginUser(credentials);
    if (res.success) {
      setCurrentUser(res.user);
      const info = getUserLoyaltyInfo(res.user.id, res.user.phone);
      setLoyaltyInfo(info);
    }
    return res;
  };

  const register = (data) => {
    const res = registerUser(data);
    if (res.success) {
      setCurrentUser(res.user);
      const info = getUserLoyaltyInfo(res.user.id, res.user.phone);
      setLoyaltyInfo(info);
    }
    return res;
  };

  const loginSocial = (socialData) => {
    const res = loginWithSocial(socialData);
    if (res.success) {
      setCurrentUser(res.user);
      const info = getUserLoyaltyInfo(res.user.id, res.user.phone);
      setLoyaltyInfo(info);
    }
    return res;
  };

  const logout = () => {
    logoutUser();
    setCurrentUser(null);
    setLoyaltyInfo({
      totalBookings: 0,
      stamps: 0,
      remainingForReward: 10,
      isRewardEligible: false,
      rewardType: 'free_haircut',
      rewardsEarned: 0
    });
  };

  return (
    <AuthContext.Provider value={{
      currentUser,
      loyaltyInfo,
      login,
      register,
      loginSocial,
      logout,
      refreshUser
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
